<template>
    <b-container fluid>
        <b-overlay :show="customLoading" rounded="sm">
            <iq-card>
                <template v-slot:headerTitle>
                    <h4 class="card-title">{{ $t('trainer_trainee.generate_certificate') + ' ' + $t('globalTrans.details') }}</h4>
                </template>
                <template v-slot:body>
                    <b-row>
                        <b-col xs="12" sm="12" md="3" lg="3" xl="3">
                            <b class="text-dark">{{ $t('globalTrans.fiscal_year') }}</b>
                        </b-col>
                        <b-col xs="12" sm="12" md="3" lg="3" xl="3">
                            <span class="text-dark">{{ getFiscalYear(formData.fiscal_year_id) }}</span>
                        </b-col>
                        <b-col xs="12" sm="12" md="3" lg="3" xl="3">
                            <b class="text-dark">{{ $t('trainer_trainee.circular_memo_no') }}</b>
                        </b-col>
                        <b-col xs="12" sm="12" md="3" lg="3" xl="3">
                            <span class="text-dark">{{ getCircularMemo(formData.circular_publication_id) }}</span>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col xs="12" sm="12" md="3" lg="3" xl="3">
                            <b class="text-dark">{{ $t('trainer_trainee.training_title') }}</b>
                        </b-col>
                        <b-col xs="12" sm="12" md="3" lg="3" xl="3">
                            <span class="text-dark">{{ getTraining(formData.training_title_id) }}</span>
                        </b-col>
                        <b-col xs="12" sm="12" md="3" lg="3" xl="3">
                            <b class="text-dark">{{ $t('trainer_trainee.batch') }}</b>
                        </b-col>
                        <b-col xs="12" sm="12" md="3" lg="3" xl="3">
                            <span class="text-dark">{{ getBatch(formData.batch_id) }}</span>
                        </b-col>
                    </b-row>
                    <!-- <b-row class="mt-3"> -->
                        <b-table-simple class="mt-3" hover bordered responsive>
                            <thead class="bg-primary" >
                                <tr>
                                    <th>{{ $t('globalTrans.sl_no') }}</th>
                                    <th>{{ $t('elearning_config.name') }}</th>
                                    <th>{{ $t('elearning_config.designation') }}</th>
                                    <th>{{ $t('trainer_trainee.org_name') }}</th>
                                    <th>{{ $t('elearning_config.contact_no') }}</th>
                                    <th>{{ $t('trainer_trainee.release') }}</th>
                                </tr>
                            </thead>
                            <b-tr v-for="(item, index) in formData.traineeList" :key="index">
                                <td>{{ $n(index + 1) }}</td>
                                <td>{{ currentLocale === 'bn' ? item.application.trainee.name_bn : item.application.trainee.name }}</td>
                                <!-- <td>{{ getDesignation(item.application.trainee.designation_id) }}</td> -->
                                <td>{{ (item.application.trainee.designation_id ? getDesignation(item.application.trainee.designation_id) : item.application.trainee.other_designation) }}</td>
                                <td>{{ getOrg(item.application.trainee.reg_org_id) }}</td>
                                <td>{{  currentLocale === 'bn' ? 'o' : '0' }}{{ $n(item.application.trainee.contact_no, {useGrouping: false}) }}</td>
                                <td>
                                    <span class="btn btn-sm btn-success" v-if="getPresentAbsent(item.batch_schedule_id, item.application.trainee_main_id) === 1">
                                        {{ $t('trainer_trainee.released') }}
                                    </span>
                                    <a v-if="getPresentAbsent(item.batch_schedule_id, item.application.trainee_main_id) === 1" href="javascript:"  class="btn btn-sm btn-primary ml-2" title="View Details" v-b-modal.modal-detail @click="details(item)">
                                        {{ $t('trainer_trainee.generate_certificate') }}
                                    </a>
                                    <span class="btn btn-sm btn-danger" v-if="getPresentAbsent(item.batch_schedule_id, item.application.trainee_main_id) === 2">
                                        {{ $t('trainer_trainee.not_release') }}
                                    </span>
                                </td>
                            </b-tr>
                        </b-table-simple>
                    <!-- </b-row> -->
                    <div class="row">
                        <div class="col-sm-3"></div>
                        <div class="col text-right">
                            <router-link :to="{name: 'training_e_learning_service.trainer_trainee_info_management.generate_certificate'}" :class="'btn btn-success text-light fontcus'">
                                {{ $t('globalTrans.back')}}
                            </router-link>
                        </div>
                    </div>
                </template>
            </iq-card>
        </b-overlay>
        <b-modal id="modal-detail" size="lg" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
            <Details :item="items" :key="editItemId"/>
        </b-modal>
    </b-container>
</template>
<script>
    import Details from './Details'
    import RestApi, { trainingElearningServiceBaseUrl } from '@/config/api_config'
    import { getScheduleBatchTrainee } from '../../api/routes'
    export default {
        props: ['id', 'item'],
        components: {
            Details
        },
        data () {
            return {
                formData: {
                    fiscal_year_id: 0,
                    circular_publication_id: 0,
                    training_title_id: 0,
                    batch_id: 0,
                    traineeList: []
                },
                items: [],
                editItemId: 0,
                customLoading: false
            }
        },
        computed: {
            currentLocale () {
                return this.$i18n.locale
            }
        },
        watch: {
        },
        created () {
            if (this.$route.params.item) {
                const tmp = this.getTrainerSelectionData()
                const newData = Object.assign(tmp, { traineeList: [] })
                this.formData = newData
                this.getScheduleTrainee()
            } else {
                this.$router.push({ name: 'training_e_learning_service.trainer_trainee_info_management.generate_certificate' })
            }
        },
        methods: {
            details (item) {
                this.items = item
                this.editItemId = item.id
            },
            detailTitle () {
                return this.$t('trainer_trainee.release_order') + ' ' + this.$t('globalTrans.details')
            },
            getTrainerSelectionData () {
                const tmpData = this.$store.state.list.find(item => item.id === this.$route.params.item.id)
                return JSON.parse(JSON.stringify(tmpData))
            },
            async getScheduleTrainee () {
                this.customLoading = true
                await RestApi.getData(trainingElearningServiceBaseUrl, getScheduleBatchTrainee, this.formData).then(response => {
                    if (response.success) {
                        this.alreadyExist = response.alreadyExist
                        this.formData.traineeList = response.data
                    } else {
                        this.formData.traineeList = []
                    }
                    this.customLoading = false
                })
            },
            getFiscalYear (fiscalYearId) {
                const fiscalObj = this.$store.state.commonObj.fiscalYearList.find(item => item.value === fiscalYearId)
                if (fiscalObj !== undefined) {
                    if (this.$i18n.locale === 'bn') {
                        return fiscalObj.text_bn
                    } else {
                        return fiscalObj.text_en
                    }
                }
            },
            getCircularMemo (circularMemoId) {
                const circularObj = this.$store.state.TrainingElearning.commonObj.circularMemoList.find(item => item.value === circularMemoId)
                if (circularObj !== undefined) {
                    if (this.$i18n.locale === 'bn') {
                        return circularObj.text_bn
                    } else {
                        return circularObj.text_en
                    }
                }
            },
            getTraining (trainingId) {
                const trainingObj = this.$store.state.TrainingElearning.commonObj.trainingNameList.find(item => item.value === trainingId)
                if (trainingObj !== undefined) {
                    if (this.$i18n.locale === 'bn') {
                        return trainingObj.text_bn
                    } else {
                        return trainingObj.text_en
                    }
                }
            },
            getBatch (batchId) {
                const batchObj = this.$store.state.TrainingElearning.commonObj.batchList.find(item => item.value === batchId)
                if (batchObj !== undefined) {
                    if (this.$i18n.locale === 'bn') {
                        return batchObj.text_bn
                    } else {
                        return batchObj.text_en
                    }
                }
            },
            getDesignation (designationId) {
                const designationObj = this.$store.state.TrainingElearning.commonObj.designationList.find(item => item.value === designationId)
                if (designationObj !== undefined) {
                    if (this.$i18n.locale === 'bn') {
                        return designationObj.text_bn
                    } else {
                        return designationObj.text
                    }
                }
            },
            getOrg (orgId) {
                const orgObj = this.$store.state.TrainingElearning.commonObj.registeredOrgList.find(item => item.value === orgId)
                if (orgObj !== undefined) {
                    if (orgObj !== undefined) {
                        if (this.$i18n.locale === 'bn') {
                            return orgObj.text_bn
                        } else {
                            return orgObj.text
                        }
                    }
                }
            },
            getPresentAbsent (batchScheduleId, traineeId) {
                const present = this.alreadyExist.find(item => item.batch_schedule_id === batchScheduleId && item.trainee_id === traineeId)
                if (present === undefined) {
                    return 2
                } else {
                    return 1
                }
            }
        }
    }
</script>
